import * as Sentry from '@sentry/react'
import { useSearch } from '@tanstack/react-router'

import { Connect } from '../components/Connect'
import { Request } from '../components/Request'
import { router } from '../router'

export function WalletConnect() {
  const { uri, provider, requestId, sessionTopic } = useSearch<typeof router>({ from: '/wc' })

  if (uri) {
    return Sentry.startSpan({ op: 'ui.render', name: 'Render Connect' }, () => (
      <Connect uri={uri} provider={provider} />
    ))
  }

  if (requestId && sessionTopic) {
    return Sentry.startSpan({ op: 'ui.render', name: 'Render Request' }, () => (
      <Request requestId={Number(requestId)} sessionTopic={sessionTopic} />
    ))
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <div className="bg-red-50 p-4 rounded-lg">
        <h2 className="text-red-800 text-lg font-semibold">Error</h2>
        <p className="text-red-600">
          Missing required parameters. Need either uri for connection or requestId and sessionTopic
          for signing.
        </p>
      </div>
    </div>
  )
}
